import {
  HRLY_DNS_REQ_STATISTICS_LIST_SET,
  HRLY_DNS_REQ_STATISTICS_LIST_REQ,
  HRLY_DNS_REQ_STATISTICS_LIST_SUCCESS,
  HRLY_DNS_REQ_STATISTICS_LIST_ERROR,
  HRLY_DNS_REQ_STATISTICS_LIST_RESET_STATUS,
  TOP_DNS_REQ_STATISTICS_LIST_SET,
  TOP_DNS_REQ_STATISTICS_LIST_REQ,
  TOP_DNS_REQ_STATISTICS_LIST_SUCCESS,
  TOP_DNS_REQ_STATISTICS_LIST_ERROR,
  TOP_DNS_REQ_STATISTICS_LIST_RESET_STATUS,
  BOTTOM_DNS_REQ_STATISTICS_LIST_SET,
  BOTTOM_DNS_REQ_STATISTICS_LIST_REQ,
  BOTTOM_DNS_REQ_STATISTICS_LIST_SUCCESS,
  BOTTOM_DNS_REQ_STATISTICS_LIST_ERROR,
  BOTTOM_DNS_REQ_STATISTICS_LIST_RESET_STATUS,
  NEW_DNS_REQ_STATISTICS_LIST_SET,
  NEW_DNS_REQ_STATISTICS_LIST_REQ,
  NEW_DNS_REQ_STATISTICS_LIST_SUCCESS,
  NEW_DNS_REQ_STATISTICS_LIST_ERROR,
  NEW_DNS_REQ_STATISTICS_LIST_RESET_STATUS,
  DNS_REQ_HOST_STATISTICS_LIST_SET,
  DNS_REQ_HOST_STATISTICS_LIST_REQ,
  DNS_REQ_HOST_STATISTICS_LIST_SUCCESS,
  DNS_REQ_HOST_STATISTICS_LIST_ERROR,
  DNS_REQ_HOST_STATISTICS_LIST_RESET_STATUS
} from './dns-statistics.type'

import ApiRest from '@/api/api-rest'
import HourlyStatistics from '@/resources/models/HourlyStatistics'
import IQCollection from '@/resources/collections/IQCollection'
import Base from '@/resources/Base'
import { getStatisticsTimeRangeFormat, getStatisticsTooltipTimeRangeFormat } from '@/utilities/statistics.helper'
import { minutesToMilliseconds } from '@/utilities/datetime.helper.js'

const state = {
  hrlyDnsRequestStatisticsReqStatus: '',
  hrlyDnsRequestStatistics: {},
  topDnsRequestStatisticsReqStatus: '',
  topDnsRequestStatistics: {},
  bottomDnsRequestStatisticsReqStatus: '',
  bottomDnsRequestStatistics: {},
  newDnsRequestStatisticsReqStatus: '',
  newDnsRequestStatistics: {},
  dnsRequestHostStatisticsReqStatus: '',
  dnsRequestHostStatistics: {}
}

const getters = {
  hrlyDnsRequestStatisticsReqStatus: state => state.hrlyDnsRequestStatisticsReqStatus,
  hrlyDnsRequestStatistics: state => state.hrlyDnsRequestStatistics,
  topDnsRequestStatisticsReqStatus: state => state.topDnsRequestStatisticsReqStatus,
  topDnsRequestStatistics: state => state.topDnsRequestStatistics,
  bottomDnsRequestStatisticsReqStatus: state => state.bottomDnsRequestStatisticsReqStatus,
  bottomDnsRequestStatistics: state => state.bottomDnsRequestStatistics,
  newDnsRequestStatisticsReqStatus: state => state.newDnsRequestStatisticsReqStatus,
  newDnsRequestStatistics: state => state.newDnsRequestStatistics,
  dnsRequestHostStatisticsReqStatus: state => state.dnsRequestHostStatisticsReqStatus,
  dnsRequestHostStatistics: state => state.dnsRequestHostStatistics
}

const mutations = {
  [HRLY_DNS_REQ_STATISTICS_LIST_SET]: (state, data) => {
    state.hrlyDnsRequestStatistics = data
  },
  [HRLY_DNS_REQ_STATISTICS_LIST_REQ]: state => {
    state.hrlyDnsRequestStatisticsReqStatus = 'loading'
  },
  [HRLY_DNS_REQ_STATISTICS_LIST_SUCCESS]: state => {
    state.hrlyDnsRequestStatisticsReqStatus = 'saved'
  },
  [HRLY_DNS_REQ_STATISTICS_LIST_ERROR]: state => {
    state.hrlyDnsRequestStatisticsReqStatus = 'error'
  },
  [HRLY_DNS_REQ_STATISTICS_LIST_RESET_STATUS]: state => {
    state.hrlyDnsRequestStatisticsReqStatus = 'loading'
  },
  [TOP_DNS_REQ_STATISTICS_LIST_SET]: (state, data) => {
    state.topDnsRequestStatistics = data
  },
  [TOP_DNS_REQ_STATISTICS_LIST_REQ]: state => {
    state.topDnsRequestStatisticsReqStatus = 'loading'
  },
  [TOP_DNS_REQ_STATISTICS_LIST_SUCCESS]: state => {
    state.topDnsRequestStatisticsReqStatus = 'saved'
  },
  [TOP_DNS_REQ_STATISTICS_LIST_ERROR]: state => {
    state.topDnsRequestStatisticsReqStatus = 'error'
  },
  [BOTTOM_DNS_REQ_STATISTICS_LIST_SET]: (state, data) => {
    state.bottomDnsRequestStatistics = data
  },
  [BOTTOM_DNS_REQ_STATISTICS_LIST_REQ]: state => {
    state.bottomDnsRequestStatisticsReqStatus = 'loading'
  },
  [BOTTOM_DNS_REQ_STATISTICS_LIST_SUCCESS]: state => {
    state.bottomDnsRequestStatisticsReqStatus = 'saved'
  },
  [BOTTOM_DNS_REQ_STATISTICS_LIST_ERROR]: state => {
    state.bottomDnsRequestStatisticsReqStatus = 'error'
  },
  [NEW_DNS_REQ_STATISTICS_LIST_SET]: (state, data) => {
    state.newDnsRequestStatistics = data
  },
  [NEW_DNS_REQ_STATISTICS_LIST_REQ]: state => {
    state.newDnsRequestStatisticsReqStatus = 'loading'
  },
  [NEW_DNS_REQ_STATISTICS_LIST_SUCCESS]: state => {
    state.newDnsRequestStatisticsReqStatus = 'saved'
  },
  [NEW_DNS_REQ_STATISTICS_LIST_ERROR]: state => {
    state.newDnsRequestStatisticsReqStatus = 'error'
  },
  [DNS_REQ_HOST_STATISTICS_LIST_SET]: (state, data) => {
    state.dnsRequestHostStatistics = data
  },
  [DNS_REQ_HOST_STATISTICS_LIST_REQ]: state => {
    state.dnsRequestHostStatisticsReqStatus = 'loading'
  },
  [DNS_REQ_HOST_STATISTICS_LIST_SUCCESS]: state => {
    state.dnsRequestHostStatisticsReqStatus = 'saved'
  },
  [DNS_REQ_HOST_STATISTICS_LIST_ERROR]: state => {
    state.dnsRequestHostStatisticsReqStatus = 'error'
  },
  [DNS_REQ_HOST_STATISTICS_LIST_RESET_STATUS]: state => {
    state.dnsRequestHostStatisticsReqStatus = ''
  }
}

const actions = {
  [HRLY_DNS_REQ_STATISTICS_LIST_REQ] (context, statsQuery) {
    let statsUrl = '/bi/searchquery/dns-requests'
    if (!_.isEmpty(statsQuery.agentId)) {
      statsUrl = `${statsUrl}/${statsQuery.agentId}`
    }
    return new Promise((resolve, reject) => {
      context.commit(HRLY_DNS_REQ_STATISTICS_LIST_REQ)
      ApiRest()
        .post(statsUrl, {
          date_range: statsQuery.queryDate,
          entities: statsQuery.domainName
        })
        .then(({ data }) => {
          let hrlyDnsReqStats = new HourlyStatistics('', data, {
            date: statsQuery.queryDate,
            labelCallback: getStatisticsTimeRangeFormat,
            labelProperty: 'epochMinutes',
            labelValue: 'count',
            title: 'DNS Requests',
            backgroundColor: '#e4f3ff',
            borderColor: '#1a90fa',
            chartOptions: {
              layout: {
                padding: {
                  left: 25
                }
              },
              title: {
                display: true,
                text: 'Count of DNS Requests'
              },
              tooltips: {
                enabled: true,
                callbacks: {
                  title: function (tooltipItems, data) {
                    let statValue = data.datasets[0].stats[tooltipItems[0].index]
                    return getStatisticsTooltipTimeRangeFormat(data.datasets[0].date, statValue['epochMinutes'])
                  }
                }
              },
              scales: {
                xAxes: [
                  {
                    offset: true,
                    type: 'time'
                  }
                ]
              },
              legend: {
                display: false
              },
              subtitle: 'Count'
            }
          })

          context.commit(HRLY_DNS_REQ_STATISTICS_LIST_SET, hrlyDnsReqStats)
          resolve(hrlyDnsReqStats)
        })
        .catch(errMsg => {
          context.commit(HRLY_DNS_REQ_STATISTICS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [HRLY_DNS_REQ_STATISTICS_LIST_SUCCESS] (context) {
    context.commit(HRLY_DNS_REQ_STATISTICS_LIST_SUCCESS)
  },
  [HRLY_DNS_REQ_STATISTICS_LIST_RESET_STATUS] (context) {
    context.commit(HRLY_DNS_REQ_STATISTICS_LIST_RESET_STATUS)
  },
  [TOP_DNS_REQ_STATISTICS_LIST_REQ] (context, statsQuery) {
    let statsUrl = '/bi/searchquery/dns-requests'
    if (!_.isEmpty(statsQuery.agentId)) {
      statsUrl = `${statsUrl}/${statsQuery.agentId}`
    }
    return new Promise((resolve, reject) => {
      context.commit(TOP_DNS_REQ_STATISTICS_LIST_REQ)
      ApiRest()
        .post(statsUrl, {
          top: true,
          date_range: statsQuery.queryDate
        })
        .then(({ data }) => {
          context.commit(TOP_DNS_REQ_STATISTICS_LIST_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TOP_DNS_REQ_STATISTICS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TOP_DNS_REQ_STATISTICS_LIST_SUCCESS] (context) {
    context.commit(TOP_DNS_REQ_STATISTICS_LIST_SUCCESS)
  },
  [BOTTOM_DNS_REQ_STATISTICS_LIST_REQ] (context, statsQuery) {
    let statsUrl = '/bi/searchquery/dns-requests'
    if (!_.isEmpty(statsQuery.agentId)) {
      statsUrl = `${statsUrl}/${statsQuery.agentId}`
    }
    return new Promise((resolve, reject) => {
      context.commit(BOTTOM_DNS_REQ_STATISTICS_LIST_REQ)
      ApiRest()
        .post(statsUrl, {
          bottom: true,
          date_range: statsQuery.queryDate
        })
        .then(({ data }) => {
          context.commit(BOTTOM_DNS_REQ_STATISTICS_LIST_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(BOTTOM_DNS_REQ_STATISTICS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [BOTTOM_DNS_REQ_STATISTICS_LIST_SUCCESS] (context) {
    context.commit(BOTTOM_DNS_REQ_STATISTICS_LIST_SUCCESS)
  },
  [NEW_DNS_REQ_STATISTICS_LIST_REQ] (context, statsQuery) {
    let statsUrl = '/bi/searchquery/dns-requests'
    if (!_.isEmpty(statsQuery.agentId)) {
      statsUrl = `${statsUrl}/${statsQuery.agentId}`
    }
    return new Promise((resolve, reject) => {
      context.commit(NEW_DNS_REQ_STATISTICS_LIST_REQ)
      ApiRest()
        .post(statsUrl, {
          new: true,
          date_range: statsQuery.queryDate
        })
        .then(({ data }) => {
          context.commit(NEW_DNS_REQ_STATISTICS_LIST_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(NEW_DNS_REQ_STATISTICS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [NEW_DNS_REQ_STATISTICS_LIST_SUCCESS] (context) {
    context.commit(NEW_DNS_REQ_STATISTICS_LIST_SUCCESS)
  },
  [DNS_REQ_HOST_STATISTICS_LIST_REQ] (context, statsQuery) {
    if (_.isEmpty(statsQuery.position)) {
      statsQuery.position = 'top'
    }
    let statsUrl = '/bi/searchquery/dns-requests/hosts'

    if (!_.isEmpty(statsQuery.agentId)) {
      statsUrl = `${statsUrl}/${statsQuery.agentId}`
    }

    if (!_.isEmpty(statsQuery.domainNames)) {
      if (!_.isArray(statsQuery.domainNames)) {
        statsQuery.domainNames = [statsQuery.domainNames]
      }
    }
    let poistionKey = statsQuery.position
    let postBody = {
      date_range: statsQuery.queryDate,
      entities: statsQuery.domainNames
    }
    postBody[poistionKey] = true
    return new Promise((resolve, reject) => {
      context.commit(DNS_REQ_HOST_STATISTICS_LIST_REQ)
      ApiRest()
        .post(statsUrl, postBody)
        .then(({ data }) => {
          let startTree = 1
          let showChildren = false
          if (_.has(statsQuery, 'showChildren')) {
            showChildren = statsQuery.showChildren
          }
          data = _.chain(data)
            .groupBy('topLevelDomain')
            .map((groupByDnsChildren, dns) => {
              let groupByDns = new Base('topLevelDomain', {
                id: startTree++,
                topLevelDomain: dns,
                sourceComm: '',
                count: '',
                epochMinutes: minutesToMilliseconds(groupByDnsChildren[0].epochMinutes)
              })
              if (showChildren) {
                for (let childGroupby of groupByDnsChildren) {
                  childGroupby.id = startTree++
                  childGroupby.topLevelDomain = ''
                  childGroupby.parentTopLevelDomain = dns
                  childGroupby.epochMinutes = minutesToMilliseconds(childGroupby.epochMinutes)
                }
                groupByDns.children = groupByDnsChildren
              } else {
                groupByDns.sourceComm = groupByDnsChildren[0].sourceComm
                groupByDns.count = groupByDnsChildren[0].count
              }
              return groupByDns
            })
            .value()
          data = new IQCollection(data, {}, { recordsPerPage: 25 })
          data.setIdentifier('topLevelDomain')
          context.commit(DNS_REQ_HOST_STATISTICS_LIST_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(DNS_REQ_HOST_STATISTICS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [DNS_REQ_HOST_STATISTICS_LIST_SUCCESS] (context) {
    context.commit(DNS_REQ_HOST_STATISTICS_LIST_SUCCESS)
  },
  [DNS_REQ_HOST_STATISTICS_LIST_RESET_STATUS] (context) {
    context.commit(DNS_REQ_HOST_STATISTICS_LIST_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics/dns-statistics.module.js